import React, { useEffect } from "react";

import {
  MainWrapper,
  PrimaryTabNewTheme,
  PrimaryTabs,
  PrimaryTabsWrapper,
  SubTabNewTheme,
  SubTabs,
  SubTabsWrapper,
} from "../../components/StyledComponent";
import useLandUseLogic from "./helpers/useLandUseLogic";
import SubStep1 from "./Step1/SubStep1";
import SubStep4 from "./Step1/SubStep4";
import { Card } from "react-bootstrap";
import TakeActionItem from "../../../../../../../templates/Forms/TakeActionItem";
// import LandUseNOC2 from "../../../../../components/LandUseNOC/LandUseNOC2";
import Step2 from "./Step2/Step2";
import { Box } from "@mui/material";
import ButtonWrapper from "../../components/Button";
import ReactToPrint from "react-to-print";
import SubStep3 from "./Step1/SubStep3";
import { BackButton, Toast } from "@egovernments/digit-ui-react-components";
import useLocalizedData from "../../../../../utils/hooks/useLocalizedData";
import { landUseSubTabLabels, primaryTabLabels, SidebarLabelsLandUse } from "../../components/data";
import { genderData, landSubUseTypes, landUseList, landUsesSchemeTypeList } from "../../../TCPForms/data";
import SubStep5 from "./Step1/SubStep5/SubStep5";

const OldLandUse = () => {
  const {
    id,
    Modal,
    dispatch,
    initFormMTDocs,
    resetFormMTDocs,
    t,
    history,
    tenantId,

    userInfo,
    applicationData,
    isAppDataLoading,
    summaryRef,
    params,
    setParams,
    clearParams,
    updateApiCall,
    activeTab,
    setActiveTab,
    showToast,
    setShowToast,
    handleTabChange,
    Loader,
    handleSubTabChange,
    applicationFlow,
    officesList,
    setSubActiveTab,
    subActiveTab,
    archData,
    validity,
    DepartmentSelector,
    usersData,
    landSubUseTypes2,
    closeToast,
    departmentList,
    schemeTypeData,
    nonSchemeTypeData,
    avpList,
    avpData,
    avpUnits,
    // villagesData,
    avpLogo,
    daLogo,
    selectedModule,
  } = useLandUseLogic();

  const {
    LANDUSE,
    ST_LABELS: subTabLabels,
    PT_LABELS: primaryTab,
    GENDER: genderList,
    SUBTYPE: landSubUses,
    LULIST: landUseListActivities,
    LUSCHEMELIST: landUsesSchemeList,
  } = useLocalizedData({
    LANDUSE: SidebarLabelsLandUse,
    ST_LABELS: landUseSubTabLabels,
    PT_LABELS: primaryTabLabels,
    GENDER: genderData,
    SUBTYPE: landSubUseTypes,
    LULIST: landUseList,
    LUSCHEMELIST: landUsesSchemeTypeList,
  });
  console.log(applicationData, params, validity, "app_data");
  const applicationNumber = params?.applicationNo;
  const [subLabelsList, setSubLabelsList] = React.useState(subTabLabels);
  const resetForm = () => {
    // setParams(applicationData);
    resetFormMTDocs();
    // setActiveTab(0);
    // setSubActiveTab(0);
  };
  const populateForm = () => {
    setParams(applicationData);
    if (applicationData?.documents?.length > 0) {
      initFormMTDocs(applicationData.documents);
    }
  };
  useEffect(() => {
    Digit.SessionStorage.set("FILE_NO");
    Digit.SessionStorage.set("OWNER_INFO");
  }, []);

  useEffect(() => {
    if (selectedModule) {
      setSubLabelsList((prev) => [...prev, { text: selectedModule }]);
    }
  }, [selectedModule]);

  const handleFormMode = () => {
    if (id && applicationData) {
      console.log("insideIf ID");
      populateForm();
    } else if (!id && applicationData) {
      console.log("insideIf not ID");
      resetForm();
    }
  };
  // useEffect(() => {
  //   console.log("Inside useEffect", applicationData);

  //   handleFormMode();
  // }, [id, applicationData]);
  useEffect(() => {
    setParams(applicationData);
    if (applicationData?.documents?.length > 0) {
      initFormMTDocs(applicationData.documents);
    } else {
      resetFormMTDocs();
    }
  }, [id, isAppDataLoading]);
  const renderContent = () => {
    if (activeTab === 0) {
      switch (subActiveTab) {
        case 0:
          return (
            <SubStep1
              formData={params}
              handleSubTabChange={handleSubTabChange}
              t={t}
              applicationFlow={applicationFlow}
              officesList={officesList}
              avpData={avpData}
              avpUnits={avpUnits}
              setParams={setParams}
              initFormMTDocs={initFormMTDocs}
              setShowToast={setShowToast}
              usersData={usersData}
            />
          );
        // case 1:
        //   return <SubStep2 formData={params} handleSubTabChange={handleSubTabChange} t={t} genderData={genderList} id={id} />;
        case 1:
          return (
            <SubStep3 formData={params} handleSubTabChange={handleSubTabChange} t={t} archData={archData} validity={validity} usersData={usersData} />
          );
        case 2:
          return (
            <SubStep4
              formData={params}
              handleSubTabChange={handleSubTabChange}
              handleTabChange={handleTabChange}
              t={t}
              landSubUseTypes={landSubUses}
              landUseListActivities={landUseListActivities}
              landUsesSchemeTypeList={landUsesSchemeList}
              landSubUseTypes2={landSubUseTypes2}
              tenantId={tenantId}
              departmentList={departmentList}
              schemeTypeData={schemeTypeData}
              nonSchemeTypeData={nonSchemeTypeData}
              avpList={avpList}
              applicationFlow={applicationFlow}
              avpData={avpData}
              // villagesData={villagesData}
            />
          );
        case 3:
          return (
            <SubStep5 formData={params} module={selectedModule} handleSubTabChange={handleSubTabChange} handleTabChange={handleTabChange} t={t} />
          );
        default:
          return null;
      }
    } else if (activeTab === 1) {
      return <Step2 formData={params} isUpdating={updateApiCall.isLoading} handleTabChange={handleTabChange} t={t} initFormMTDocs={initFormMTDocs} />;
      // } else if (activeTab === 2) {
      //   return <Step3 formData={params} isUpdating={updateApiCall.isLoading} handleTabChange={handleTabChange} initFormMTDocs={initFormMTDocs} />;
    }
    // else if (activeTab === 2) {
    //   // return <LandUseNOC2 formData={params} role={"CITIZEN"} handleTabChange={handleTabChange} Modal={Modal} />;
    //   return <LandUseNOC formData={params} role={"CITIZEN"} handleTabChange={handleTabChange} Modal={Modal} />;
    // }

    if (activeTab === 2 && applicationNumber) {
      return (
        <div>
          <Card style={{ marginTop: "20px" }}>
            <TakeActionItem
              formType={"formLandUse"}
              id={applicationNumber}
              ref={summaryRef}
              logoData={applicationFlow == "DA" ? daLogo : avpLogo}
              oldCaseSearch={true}
            />
            <div className="footerContainer">
              <div className="buttonWrapper">
                <ReactToPrint
                  trigger={() => (
                    <ButtonWrapper variant="contained" color="success" size="medium" label="Print" sx={{ backgroundColor: "#000" }}>
                      Print Summary
                    </ButtonWrapper>
                  )}
                  content={() => summaryRef.current}
                />
                <ButtonWrapper
                  variant="contained"
                  color="error"
                  size="medium"
                  label="Preview"
                  sx={{ backgroundColor: "#CCC" }}
                  onClick={() => {
                    handleTabChange(0);
                    handleSubTabChange(0);
                  }}
                />
                <ButtonWrapper
                  variant="contained"
                  color="success"
                  size="medium"
                  label="Submit"
                  type="submit"
                  sx={{ backgroundColor: "#000" }}
                  onClick={() => handleTabChange(4, params)}
                />
              </div>
            </div>
          </Card>
        </div>
      );
    }
  };
  useEffect(() => {
    if (!showToast) return;
    const timeOut = setTimeout(closeToast, 2000);
    return () => clearTimeout(timeOut);
  }, [showToast]);

  if (isAppDataLoading || (id && !applicationData)) {
    return <Loader />;
  }
  if (id) {
    if (!params?.landInfo?.owners?.[0]?.correspondenceAddress?.town) {
      return <Loader />;
    }
  }
  if (applicationFlow === null) {
    return <DepartmentSelector />;
  }

  return (
    <React.Fragment>
      <MainWrapper>
        {/* <HeaderContent applicationFlow={applicationFlow} /> */}
        <BackButton />
        <Box sx={{ boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)", overflowY: "auto", padding: "20px" }} className="bg-white">
          <div className="formStripLandUse mb-3 border-0">
            <h2>Land Use for Old Cases</h2>
          </div>
          <div className="main-panel-corner land-use-corner">
            <div className="left-corner">
              <PrimaryTabsWrapper>
                {/* Tabs Header */}
                <PrimaryTabs value={activeTab} onChange={(e, i) => setActiveTab(i)} aria-label="Tab Group" variant="scrollable" scrollButtons="auto">
                  {primaryTab.map((item, index) => (
                    <PrimaryTabNewTheme key={`${item.text}.${index}`} label={item.text} />
                  ))}
                </PrimaryTabs>
              </PrimaryTabsWrapper>
            </div>
            <div className="right-corner">
              <div>
                {activeTab === 0 && (
                  <SubTabsWrapper>
                    <SubTabs
                      value={subActiveTab}
                      onChange={(e, i) => handleSubTabChange(i)}
                      aria-label="Sub Tab Group"
                      variant="scrollable"
                      scrollButtons="auto"
                    >
                      {subLabelsList?.map((tab, index) => (
                        <SubTabNewTheme key={`${tab.text}.${index}`} label={tab.text} />
                      ))}
                    </SubTabs>
                  </SubTabsWrapper>
                )}
                {renderContent()}
              </div>

              {/* <StyledDivider /> */}
            </div>
          </div>
        </Box>
      </MainWrapper>
      {showToast && (
        <Toast error={showToast?.error} warning={showToast?.warning} label={t(showToast?.message)} onClose={closeToast} isDeleteBtn={true} />
      )}
    </React.Fragment>
  );
};

export default OldLandUse;
